// app/src/components/desktop/HeaderDesktopPro.tsx
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelectorDesktop from "../atomicDesignDesktop/LanguageSelectorDesktop";
import { useUrlContext } from "../../../contexts/UrlContext";


const HeaderDesktopPro: FC = () => {
	const { t } = useTranslation();
	const { redirectToContactUsPro, redirectToHomePro, goBackWithFallback } = useUrlContext();
	
	return (
		<header
			style={{
				height: 94,
				width: 1761,
				margin: '15px 0',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
			}}
		>
			<div
				style={{
					width: 350,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'left',
					alignItems: 'center',
					gap: 10,
					cursor: 'pointer',
				}}
			>
				<img
					src="/images/chevron-left.svg"
					alt="left-chevron"
					style={{ width: 20 }}
				/>
				<div
					style={{ fontSize: 20 }}
					onClick={() => {

						goBackWithFallback();
					}}
				>
					{t('header:back')}
				</div>
			</div>
			
			<img
				src="/images/logo-VPauto-pro.svg"
				alt="VPAuto logo"
				style={{ width: 218,cursor: 'pointer',}}
				onClick={redirectToHomePro}
			/>
			
			<div
				style={{
					width: 350,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'right',
					alignItems: 'center',
					gap: 40,
				}}
			>
				<div
					style={{
						fontSize: 16,
						fontWeight: 'bold',
						cursor: 'pointer',
					}}
					onClick={redirectToContactUsPro}
				>
					{t('header:contactUs')}
				</div>
				<LanguageSelectorDesktop/>
			</div>
		</header>
	);
};

export default HeaderDesktopPro;
